import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';

import { ForgotPasswordComponent } from './modules/authentication/components/forgot-password/forgot-password.component';
import { LoginComponent } from './modules/authentication/components/login/login.component';
import { RegisterComponent } from './modules/authentication/components/register/register.component';
import { MainAuthenticationComponent } from './template/templates/main-authentication/main-authentication.component';

import { MainComponent } from './template/templates/main/main.component';
import { HomeComponent } from './template/pages/home/home.component';
import { NotAvailableComponent } from './template/pages/not-available/not-available.component';
import { NotFoundComponent } from './template/pages/not-found/not-found.component';

import { TutorInfoComponent } from './modules/tutors/pages/tutor-info/tutor-info.component';
import { TutorEditionComponent } from './modules/tutors/pages/tutor-edition/tutor-edition.component';

import { StudentsListComponent } from './modules/students/pages/students-list/students-list.component';
import { StudentInfoComponent } from './modules/students/pages/student-info/student-info.component';
import { StudentEditionComponent } from './modules/students/pages/student-edition/student-edition.component';

import { EnrollmentsListComponent } from './modules/enrollments/pages/enrollments-list/enrollments-list.component';
import { EnrollmentInfoComponent } from './modules/enrollments/pages/enrollment-info/enrollment-info.component';
import { EnrollmentNewComponent } from './modules/enrollments/pages/enrollment-new/enrollment-new.component';
import { EnrollmentPaymentResultComponent } from './modules/enrollments/pages/enrollment-payment-result/enrollment-payment-result.component';

const routes: Routes = [

    {
        path: '',
        component: MainAuthenticationComponent,
        children: [
            { path: '',         redirectTo: 'login', pathMatch: 'full' },
            { path: 'login', 	component: LoginComponent              },
            { path: 'registro', component: RegisterComponent           },
            { path: 'recuperar-password', component: ForgotPasswordComponent     }
        ]
    },
    {
        path: '',
        component: MainComponent,
        canActivate: [ AuthGuard ],
        children: [
            {
                path: 'home',
                component: HomeComponent
            },
            {
                path: 'tutor',
                component: TutorInfoComponent
            },
            {
                path: 'tutor/edicion',
                component: TutorEditionComponent
            },
            {
                path: 'participantes',
                component: StudentsListComponent
            },
            {
                path: 'participante/:id/info',
                component: StudentInfoComponent
            },
            {
                path: 'participante/:id/edicion',
                component: StudentEditionComponent
            },
            {
                path: 'participante/nuevo',
                component: StudentEditionComponent
            },
            {
                path: 'inscripciones',
                component: EnrollmentsListComponent
            },
            {
                path: 'inscripcion/:code/info',
                component: EnrollmentInfoComponent
            },
            {
                path: 'inscripcion/nueva',
                component: EnrollmentNewComponent
            },
            {
                path: 'inscripcion/:code/pago/ok',
                component: EnrollmentPaymentResultComponent
            },
            {
                path: 'inscripcion/:code/pago/ko',
                component: EnrollmentPaymentResultComponent
            }
        ]
    },

    { path: 'not-available', component: NotAvailableComponent },
    { path: 'not-found',     component: NotFoundComponent     },
    { path: '**',            redirectTo: '/not-found'         }

];

@NgModule({

    imports: [
      RouterModule.forRoot(routes, { useHash: true })
    ],

    exports: [
      RouterModule
    ]

})
export class AppRoutingModule { }
